import React, { useEffect, useState } from "react";

import {
  Box,
  Grid,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  TextField,
} from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";

import HomeIcon from "@mui/icons-material/Home";

import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";
import PublicIcon from "@mui/icons-material/Public";
import { useTheme } from "@mui/material/styles";
import { styled } from "@mui/material/styles";

import Paper from "@mui/material/Paper";

import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Buttons, TypographyText, useScreenSize } from "../Reuse/Reuse";
import { Link } from "react-router-dom";

const Contact = () => {
  //   const { data } = Bannerimage8();
  //console.log(data, "data");
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <div id="contactme">
     
      <Box sx={{ backgroundColor: "#132B2C", padding: "5%" ,
       textAlign: "center",
       display: "flex",
       flexDirection: "column",
       alignItems: "center",
       justifyContent: "center",
      }}>
        <TypographyText
          Typography={
            <>
              Partner with Vell Biologics, today
            </>
          }
          textAlign="center"
          color="whitesmoke"
          fontSize="2rem"
        />
     <br/>
     <Link to={'/contact'}>
     <Buttons
                Buttonname={"Contact Us"}
                fontWeight="bolder"
                color="white"
                bgcolor="#BA4454"
                bgcolor1="#BA4454"
                color1="white"
               textAlign="centre"
                type="submit"
              
              /></Link>
    
      </Box>
    </div>
  );
};

export default Contact;
const Address = [
  {
    SocialIcon: <HomeIcon sx={{ color: "#132B2C" }} />,
    text: <> Corporate Office</>,
    text1: (
      <>
        SriDevi Nilaya #50, 7th Main Road,
        <br />
        Mahalakshmi Layouth Bangalore, India
      </>
    ),
  },
];

const Address1 = [
  {
    SocialIcon: <EmailIcon sx={{ color: "#132B2C" }} />,

    text1: "",
  },
];
const Address2 = [
  {
    SocialIcon: <PhoneIcon sx={{ color: "#132B2C" }} />,

    text1: <></>,
  },
];
const Address3 = [
  {
    SocialIcon: <PublicIcon sx={{ color: "#132B2C" }} />,

    text1: <></>,
  },
];
